import { configureStore } from '@reduxjs/toolkit';
//CATALOGS
import users from './slices/catalogs/users.slice';
import isLoadingSlice from './slices/isLoading.slice';
import donwloadFile from './slices/donwloadFile.slice';
import roles from './slices/catalogs/roles.slice';
import students from './slices/catalogs/students.slice';
import events from './slices/catalogs/events.slice'
import levels from './slices/catalogs/levels.slice';
import parallels from './slices/catalogs/parallels.slice';
import courses from './slices/catalogs/courses.slice';
import fathers from './slices/catalogs/father.slice';
import politics from './slices/catalogs/politics.slice';
import contracts from './slices/catalogs/contracts.slice';
import documents from './slices/catalogs/documents.slice';
import forms from './slices/catalogs/forms.slice';
import questions from './slices/catalogs/questions.slice';
import configurations from './slices/catalogs/config.slice';
import data_students_excel from './slices/catalogs/uploadStudentData.slice';
import data_levels_excel from './slices/catalogs/uploadLevelData.slice';
import data_courses_excel from './slices/catalogs/uploadCoursesData.slice';
import data_parallels_excel from './slices/catalogs/uploadParallesData.slice';

//PUBLIC
import parents from './slices/public/parents.slice';
import aceptacion_politicas from './slices/public/aceptacionPoliticas.slice';
import reservacion_cupo from './slices/public/reservacionCupo.slice';
import proceso_matriculacion from './slices/public/procesoMatriculacion.slice';

//REPORTS
import reports from './slices/reportes/reports.slice';

export default configureStore({
  reducer: {
    isLoadingSlice,
    donwloadFile,
    users,
    parents,
    roles,
    students,
    events,
    fathers,
    levels,
    parallels,
    courses,
    politics,
    contracts,
    documents,
    forms,
    questions,
    configurations,
    data_students_excel,
    data_courses_excel,
    data_parallels_excel,
    data_levels_excel,
    aceptacion_politicas,
    reservacion_cupo,
    proceso_matriculacion,
    reports

  }
})